import { Routes, Route } from 'react-router-dom';
import { ProtectedRoute } from './components/ProtectedRoute.js';
import { DashboardPage } from './pages/DashboardPage.js';
import { MyScoresPage } from './pages/MyScoresPage.js';
import { LeaderboardPage } from './pages/LeaderboardPage.js';
import { InvitationsPage } from './pages/InvitationsPage.js';
import { StationsPage } from './pages/StationsPage.js';
import { ScanPage } from './pages/ScanPage.js';
import { LoginPage } from './pages/LoginPage.js';

export function App(): JSX.Element {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <DashboardPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/scores"
        element={
          <ProtectedRoute>
            <MyScoresPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/leaderboard"
        element={
          <ProtectedRoute>
            <LeaderboardPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/invitations"
        element={
          <ProtectedRoute>
            <InvitationsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/stations"
        element={
          <ProtectedRoute>
            <StationsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/scan"
        element={
          <ProtectedRoute>
            <ScanPage />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}
